import * as moment from "moment";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { SortieSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SortieSalarieDto";
import DataTestIDHelper from "../../Helper/DataTestID/DataTestIDHelper";
import formulaireEntreeSortieHelper from "../../Helper/formulaireEntreeSortieHelper";
import { FiltreEntreeSortie } from "../../shared/Enums/listeEntreesSortiesSalarie/filtreEntreeSortie";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "../Controls/EventBus";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { ParametresInstance } from "../Controls/Parameters";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";

@Component({
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as ListeSortiesSalarieComponent);
            vm.fetchData();
        });
    },
    beforeRouteUpdate(to, from, next) {
        next(v => {
            const vm = v as ListeSortiesSalarieComponent;
            vm.fetchData();
        });
    },
})
export default class ListeSortiesSalarieComponent extends Vue {
    public sorties: SortieSalarieDto[] = [];
    public sortiesFiltred: SortieSalarieDto[] = [];

    public currentOrderColumn = "DateCreation";
    public orderingDesc = false;

    public roles: string[] = [];
    public isAdminPst = false;
    public isAdmin = false;
    public isUtilisateurPst = false;

    public displayValidees = false;

    public filterName = "";
    public dataReady = false;

    public filtreEtatSortie: FiltreEntreeSortie = FiltreEntreeSortie.Tout;
    public filtreEntreeSortieEnum = FiltreEntreeSortie;

    public fetchData(): void {
        this.dataReady = false;
        this.isAdminPst = ParametresInstance.userHasRole(RoleConstants.AdministrateurPST);
        this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);
        this.isAdmin = ParametresInstance.userHasRole(RoleConstants.Administrateur);

        if (this.isAdminPst) {
            this.filtreEtatSortie = FiltreEntreeSortie.AValider;
        }

        ServicesFactoryInstance.SortieSalarieService.getSortiesSalarie(data => {
            this.sorties = data;
            this.sortiesFiltred = data;
            this.doFilter();
            this.getClassOfOrder(this.currentOrderColumn, true);
            this.dataReady = true;
        });
    }

    public getEtatDemandeEtat(estSoumise: boolean, estValidee: boolean): FiltreEntreeSortie {
        return formulaireEntreeSortieHelper.getEtatDemandeEtat(estSoumise, estValidee);
    }

    public getEtatDemandeString(EstSoumise: boolean, EstValidee: boolean): string {
        return formulaireEntreeSortieHelper.getEtatDemandeString(EstSoumise, EstValidee);
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    public orderBy(columnName: string): void {
        if (this.currentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.currentOrderColumn = columnName;
        this.doOrder();
    }

    public doOrder(): void {
        const orderingDesc = this.orderingDesc;
        const columnName = this.currentOrderColumn;
        if (this.sortiesFiltred != undefined) {
            this.sortiesFiltred.sort(function (a, b) {
                if (a[columnName] < b[columnName]) {
                    return (orderingDesc ? -1 : 1);
                }
                if (a[columnName] > b[columnName]) {
                    return (orderingDesc ? 1 : -1);
                }

                return 0;
            });
        }
    }

    public doFilter(): void {
        this.sortiesFiltred = this.sorties;
        //Filtre de recherche
        if (this.filterName) {
            this.sortiesFiltred = this.sortiesFiltred.filter(s =>
                (s.FullName != undefined && s.FullName.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.Id != undefined && s.Id.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.DateModification != undefined && moment.utc(s.DateModification).format("DD/MM/YYYY HH:mm").toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.DateCreation != undefined && moment.utc(s.DateCreation).format("DD/MM/YYYY HH:mm").toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0)
            );
        }

        //Filtre par état
        this.sortiesFiltred = this.sortiesFiltred.filter(s =>
            this.filtreEtatSortie == FiltreEntreeSortie.Tout
            || this.filtreEtatSortie == this.getEtatDemandeEtat(s.EstSoumise, s.EstValidee));

        this.doOrder();
    }

    public ouvrirSortie(id: number, fullname: string): void {
        this.openSortieSalarie(id, fullname, false)
    }

    public visualiserSortie(id: number, fullname: string): void {
        this.openSortieSalarie(id, fullname, true)
    }

    //Ouvre l'entrée avec les informations voulu
    public openSortieSalarie(id: number, fullname: string, readonly: boolean): void {
        EventBus.NavigateTo({ path: "/sortieSalarie/" + id, query: { titre: fullname !== undefined ? fullname : "Sans nom" } });
    }

    public creerSortieSalarie(): void {
        EventBus.NavigateTo({
            path: "/sortieSalarie/0",
            query: { titre: "AJOUT DE SORTIE" }
        });
    }

    public deleteItem(id: number): void {
        const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment supprimer cette sortie ?",
            callBackYes: () => {
                this.dataReady = false;

                ServicesFactoryInstance.SortieSalarieService.deleteSortieSalarie(id, () => {
                    NotificationServiceInstance.SendSuccess("Sortie supprimée avec succès.");
                    this.fetchData();
                });
            }
        });
        EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
    }

    //On peut supprimer une sortie si on est Admin PST + état = A valider ou si on est utilisateur PST + état = en cours
    public canSupprimer(EstSoumise: boolean, EstValidee: boolean): boolean {
        return formulaireEntreeSortieHelper.canSupprimerWithRole(EstSoumise, EstValidee, this.isAdminPst, this.isAdmin, this.isUtilisateurPst)
    }

    //On peut modifier une sortie si on est Admin PST + état = A valider ou si on est utilisateur PST + état = en cours
    public canModifier(EstSoumise: boolean, EstValidee: boolean): boolean {
        return formulaireEntreeSortieHelper.canModifierWithRole(EstSoumise, EstValidee, this.isAdminPst, this.isAdmin, this.isUtilisateurPst)
    }

    //On peut visualiser une sortie si état = Validees ou si on est utilisateur PST + état = A valider
    public canVisualiser(EstSoumise: boolean, EstValidee: boolean): boolean {
        return formulaireEntreeSortieHelper.canVisualiserWithRole(EstSoumise, EstValidee, this.isAdmin, this.isUtilisateurPst)
    }


    public getExitRequestState(sortie: SortieSalarieDto): string {
        return DataTestIDHelper.getExitRequestState(sortie);
    }
}



// WEBPACK FOOTER //
// ./src/components/listeSortiesSalarie/listeSortiesSalarie.ts